import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { iRoles } from "../../definitions/Roles"

const getIcon = (group: string): string => {
  switch (group) {
    case "BUSINESS":
      return "/icons/business.svg"
    case "DOCUMENT":
      return "/icons/document.svg"
    case "GLOBAL":
      return "/icons/global.svg"
    default:
      return ""
  }
}

const Item: FunctionComponent<iRoles> = ({ name, group }) => {
  return (
    <div className={`content-item roles-item`}>
      <div className="content-block">
        <h3>{name}</h3>
        <div className="icon-wrap">
          <PureImage src={getIcon(group)} />
        </div>
        <h4>{group}</h4>
      </div>
    </div>
  )
}

export default Item
